import { FilterSelectGroup } from './types';
import { i18n } from '@modernloop/i18n';
import { AutocompleteRenderGroupParams, ListSubheader, Typography } from '@mui/material';
import { has } from 'lodash';
import { z } from 'zod';

const optionWithIdSchema = z.object({ id: z.unknown() });

export const defaultRenderGroup = (params: AutocompleteRenderGroupParams) => {
  if (!params.group || params.group.trim() === '') {
    return [params.children];
  }

  return [
    <ListSubheader
      // eslint-disable-next-line no-restricted-syntax
      sx={{ alignContent: 'center' }}
      key={params.key}
      disableGutters
    >
      <Typography color="text.secondary" fontWeight={600} variant="body2">
        {params.group === FilterSelectGroup.SUGGESTED && i18n.t('hiring-dashboard-common:common.search.suggestions')}
        {params.group === FilterSelectGroup.SELECTED && i18n.t('hiring-dashboard-common:common.search.selected')}
        {params.group === FilterSelectGroup.OTHER && i18n.t('hiring-dashboard-common:common.search.other')}
        {params.group !== FilterSelectGroup.SUGGESTED &&
          params.group !== FilterSelectGroup.SELECTED &&
          params.group !== FilterSelectGroup.OTHER &&
          params.group}
      </Typography>
    </ListSubheader>,
    params.children,
  ];
};

export const defaultGetOptionSelected = <TData,>(option: TData, value: TData) => {
  if (!option || !value) {
    return false;
  }
  if (option === value) {
    return option === value;
  }

  if (has(option, 'id') && has(value, 'id')) {
    const parsedOption = optionWithIdSchema.safeParse(option);
    const parsedValue = optionWithIdSchema.safeParse(value);
    if (parsedOption.success && parsedValue.success) {
      return parsedOption.data.id === parsedValue.data.id;
    }
  }

  return false;
};
